import React from 'react';
import { CircularProgress, styled } from '@mui/material';

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1300,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
});

const TextAnimation = styled('div')({
  position: 'absolute',
  display: 'flex',
  gap: '2px',
});

const Letter = styled('span')({
  fontSize: '0.75rem',
  fontWeight: 'bold',
  color: '#616161', // Medium gray color
  animation: '$pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%, 100%': { opacity: 0.3, transform: 'translateY(0)' },
    '50%': { opacity: 1, transform: 'translateY(-5px)' },
  },
  '&:nth-of-type(2)': {
    animationDelay: '0.2s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.4s',
  },
});

export const Loader: React.FC = () => {
  return (
    <LoaderContainer>
      <CircularProgress 
        size={60} 
        thickness={4}
        sx={{ color: '#616161' }} 
      />
      <TextAnimation>
        {['S', 'M', 'P'].map((letter, index) => (
          <Letter key={index}>{letter}</Letter>
        ))}
      </TextAnimation>
    </LoaderContainer>
  );
};

